var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"4rem"}},[_c('h2',[_vm._v("404 - Página não encontrada")])])
}]

export { render, staticRenderFns }